// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Features from './pages/Features';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
// import Pricing from './pages/Pricing';
// import Videos from './pages/Videos';

const App: React.FC = () => {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/features' element={<Features />} />
        {/* <Route path='/pricing' element={<Pricing />} />
        <Route path='/videos' element={<Videos />} /> */}

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
